import React from 'react';

/**
 * ConsultantDashboardEmptyState
 *
 * Props:
 * - show: boolean
 * - onStartNewSession: () => void
 */
const ConsultantDashboardEmptyState = ({ show, onStartNewSession }) => {
  if (!show) return null;

  return (
    <div className="mb-6 bg-blue-50 dark:bg-blue-900/30 border border-blue-200 dark:border-blue-800 rounded-lg p-6 text-center">
      <svg
        className="w-12 h-12 text-blue-400 dark:text-blue-300 mx-auto mb-3"
        fill="none"
        stroke="currentColor"
        viewBox="0 0 24 24"
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={2}
          d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2"
        />
      </svg>
      <h3 className="text-lg font-medium text-blue-900 dark:text-blue-300 mb-2">
        No Engagements Yet
      </h3>
      <p className="text-blue-700 dark:text-blue-400 mb-4">
        Start your first consultant session to see it here.
      </p>
      <button
        onClick={onStartNewSession}
        className="bg-blue-600 hover:bg-blue-700 dark:bg-blue-700 dark:hover:bg-blue-600 text-white px-6 py-2 rounded-lg font-medium"
      >
        Start New Session
      </button>
    </div>
  );
};

export default ConsultantDashboardEmptyState;


